// src/components/Footer.js
import React, { useState } from "react";
import "../styles/Footer.css";

const Footer = ({ language = "fr" }) => {
  const [showLegalModal, setShowLegalModal] = useState(false);

  const openLegalModal = () => setShowLegalModal(true);
  const closeLegalModal = () => setShowLegalModal(false);

  const legalContent = {
    fr: {
      title: "Mentions Légales",
      content: `
        <h3>Informations légales</h3>
        <p><strong>Raison sociale :</strong> Studio Delémont</p>
        <p><strong>Propriétaire :</strong> Guillem Vidal</p>
        <p><strong>SIRET :</strong> 94348478200017</p>
        <p><strong>Adresse :</strong> Delémont, Canton du Jura, Suisse</p>
        <p><strong>Email :</strong> contact@studiodelemont.ch</p>
        <p><strong>Téléphone :</strong> +41 79 XXX XX XX</p>
        
        <h3>Activité</h3>
        <p>Location saisonnière d'un studio meublé de tourisme situé à Delémont, dans le canton du Jura en Suisse. Hébergement moderne et écoresponsable pour courts et moyens séjours.</p>
        
        <h3>Hébergement web</h3>
        <p>Ce site est hébergé par Netlify Inc., 2325 3rd Street, Suite 296, San Francisco, CA 94107, USA. Le code source est disponible sur GitHub sous licence libre.</p>
        
        <h3>Protection des données personnelles</h3>
        <p>Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi suisse sur la protection des données, les informations collectées via ce site sont utilisées exclusivement dans le cadre des réservations et de la gestion locative. Aucune donnée n'est transmise à des tiers à des fins commerciales.</p>
        <p>Vous disposez d'un droit d'accès, de rectification et de suppression de vos données personnelles. Pour exercer ces droits, contactez-nous à l'adresse email ci-dessus.</p>
        
        <h3>Cookies</h3>
        <p>Ce site utilise des cookies techniques nécessaires à son bon fonctionnement. Aucun cookie de tracking ou de publicité n'est utilisé.</p>
        
        <h3>Propriété intellectuelle</h3>
        <p>Le contenu de ce site (textes, images, design) est protégé par le droit d'auteur. Toute reproduction, même partielle, est interdite sans autorisation préalable.</p>
        
        <h3>Responsabilité</h3>
        <p>Les informations présentes sur ce site sont données à titre indicatif et peuvent être modifiées sans préavis. Nous nous efforçons de maintenir les informations à jour mais ne pouvons garantir leur exactitude.</p>
      `,
    },
    en: {
      title: "Legal Notice",
      content: `
        <h3>Legal Information</h3>
        <p><strong>Business name:</strong> Studio Delémont</p>
        <p><strong>Owner:</strong> Guillem Vidal</p>
        <p><strong>Registration:</strong> 94348478200017</p>
        <p><strong>Address:</strong> Delémont, Canton of Jura, Switzerland</p>
        <p><strong>Email:</strong> contact@studiodelemont.ch</p>
        <p><strong>Phone:</strong> +41 79 XXX XX XX</p>
        
        <h3>Activity</h3>
        <p>Seasonal rental of a furnished tourist studio located in Delémont, in the canton of Jura, Switzerland. Modern and eco-responsible accommodation for short and medium stays.</p>
        
        <h3>Web Hosting</h3>
        <p>This site is hosted by Netlify Inc., 2325 3rd Street, Suite 296, San Francisco, CA 94107, USA. The source code is available on GitHub under open license.</p>
        
        <h3>Personal Data Protection</h3>
        <p>In accordance with the General Data Protection Regulation (GDPR) and Swiss data protection law, information collected via this site is used exclusively for booking and rental management purposes. No data is transmitted to third parties for commercial purposes.</p>
        <p>You have the right to access, rectify and delete your personal data. To exercise these rights, contact us at the email address above.</p>
        
        <h3>Cookies</h3>
        <p>This site uses technical cookies necessary for its proper functioning. No tracking or advertising cookies are used.</p>
        
        <h3>Intellectual Property</h3>
        <p>The content of this site (texts, images, design) is protected by copyright. Any reproduction, even partial, is prohibited without prior authorization.</p>
        
        <h3>Liability</h3>
        <p>The information on this site is provided for informational purposes and may be modified without notice. We strive to keep information up to date but cannot guarantee its accuracy.</p>
      `,
    },
    de: {
      title: "Impressum",
      content: `
        <h3>Rechtliche Informationen</h3>
        <p><strong>Firmenname:</strong> Studio Delémont</p>
        <p><strong>Inhaber:</strong> Guillem Vidal</p>
        <p><strong>Registrierung:</strong> 94348478200017</p>
        <p><strong>Adresse:</strong> Delémont, Kanton Jura, Schweiz</p>
        <p><strong>E-Mail:</strong> contact@studiodelemont.ch</p>
        <p><strong>Telefon:</strong> +41 79 XXX XX XX</p>
        
        <h3>Aktivität</h3>
        <p>Saisonale Vermietung eines möblierten Touristenstudios in Delémont, im Kanton Jura, Schweiz. Moderne und umweltbewusste Unterkunft für kurze und mittlere Aufenthalte.</p>
        
        <h3>Web-Hosting</h3>
        <p>Diese Website wird von Netlify Inc., 2325 3rd Street, Suite 296, San Francisco, CA 94107, USA gehostet. Der Quellcode ist auf GitHub unter offener Lizenz verfügbar.</p>
        
        <h3>Datenschutz</h3>
        <p>In Übereinstimmung mit der Datenschutz-Grundverordnung (DSGVO) und dem Schweizer Datenschutzgesetz werden über diese Website gesammelte Informationen ausschließlich für Buchungs- und Mietverwaltungszwecke verwendet. Keine Daten werden zu kommerziellen Zwecken an Dritte weitergegeben.</p>
        <p>Sie haben das Recht auf Zugang, Berichtigung und Löschung Ihrer persönlichen Daten. Um diese Rechte auszuüben, kontaktieren Sie uns unter der oben genannten E-Mail-Adresse.</p>
        
        <h3>Cookies</h3>
        <p>Diese Website verwendet technische Cookies, die für ihr ordnungsgemäßes Funktionieren erforderlich sind. Es werden keine Tracking- oder Werbe-Cookies verwendet.</p>
        
        <h3>Geistiges Eigentum</h3>
        <p>Der Inhalt dieser Website (Texte, Bilder, Design) ist urheberrechtlich geschützt. Jede Reproduktion, auch teilweise, ist ohne vorherige Genehmigung untersagt.</p>
        
        <h3>Haftung</h3>
        <p>Die Informationen auf dieser Website dienen nur zu Informationszwecken und können ohne Vorankündigung geändert werden. Wir bemühen uns, die Informationen aktuell zu halten, können aber ihre Genauigkeit nicht garantieren.</p>
      `,
    },
  };

  const translations = {
    fr: {
      vacationRental: "Appart-hôtel",
      allRightsReserved: "Tous droits réservés",
      legalNotices: "Mentions légales",
      contactUs: "Nous contacter",
      location: "Notre localisation",
    },
    en: {
      vacationRental: "Aparthotel",
      allRightsReserved: "All rights reserved",
      legalNotices: "Legal notices",
      contactUs: "Contact us",
      location: "Our location",
    },
    de: {
      vacationRental: "Aparthotel",
      allRightsReserved: "Alle Rechte vorbehalten",
      legalNotices: "Impressum",
      contactUs: "Kontakt",
      location: "Unser Standort",
    },
  };

  const currentContent = legalContent[language] || legalContent.fr;
  const currentTranslations = translations[language] || translations.fr;

  return (
    <>
      <footer className="simple-footer">
        <div className="simple-footer-container">
          {/* Contact Info in horizontal layout */}
          <div className="simple-footer-contact">
            <div className="contact-left">
              <span className="contact-icon">📧</span>
              <a href="mailto:contact@studiodelemont.ch" className="contact-link">
                contact@studiodelemont.ch
              </a>
            </div>
            <div className="contact-center">
              <a
                href="https://www.google.com/maps/place/Delémont,+Suisse"
                target="_blank"
                rel="noopener noreferrer"
                className="address-link"
                title={currentTranslations.location}
              >
                <span className="contact-icon">📍</span>
                Rue Denise-Péronne 11, Delémont, Suisse
              </a>
            </div>
            <div className="contact-right">
              <span className="contact-icon">🏠</span>
              {currentTranslations.vacationRental}
            </div>
          </div>

          {/* Bottom line */}
          <div className="simple-footer-bottom">
            <span>
              © 2025 Studio Delémont. {currentTranslations.allRightsReserved}.
            </span>
            <button 
              onClick={openLegalModal} 
              className="legal-link"
              aria-label={currentTranslations.legalNotices}
            >
              {currentTranslations.legalNotices}
            </button>
          </div>
        </div>
      </footer>

      {/* Legal Modal */}
      {showLegalModal && (
        <div className="legal-modal-overlay" onClick={closeLegalModal}>
          <div className="legal-modal" onClick={(e) => e.stopPropagation()}>
            <div className="legal-modal-header">
              <h2>{currentContent.title}</h2>
              <button 
                onClick={closeLegalModal} 
                className="legal-modal-close"
                aria-label="Fermer"
              >
                ×
              </button>
            </div>
            <div
              className="legal-modal-content"
              dangerouslySetInnerHTML={{ __html: currentContent.content }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Footer;


